module.exports = __webpack_public_path__ + "static/media/gallery12.ab7b3754.png";